export { default as withFadeIn } from './with-fade-in';
